module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com (5).4468fb8f.svg";